export type GtmEvent = Record<string, unknown>;

/**
 * Pushes events to the Google Tag Manager data layer. The layout declares the data layer before any
 * container loads; the fallback keeps pushes harmless on a page that has none.
 */
export function useGtm() {
  const push = (event: GtmEvent): void => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  };

  return { push };
}
